import { single_mosfet_thermal } from './single_mosfet_thermal';
import { UNITS_SIGN } from '../../constants/definitionConstants';

export class nth4l020n120sc1 extends single_mosfet_thermal {
	constructor(opn) {
		super(opn, 'nth4l020n120sc1');
		this.PACKAGE_IMAGE = require(`../../images/TO247_4L_CASE_340CJ.png`);
		this.modelLink = `https://www.${this.domain}/download/models/zip/onsemi_sicmosfet_1200_pspice.zip`;
	}

	gainDefinition() {
		const customizations = {
			simulations: [
				{
					inputParameters: [
						{
							/**
							 * base heading (heading is created from heading + unit)
							 */
							heading: 'V<sub>GS<sub>(min)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							/**
							 * if unit is not base unit but for example it is in kilo ohm it is needed
							 * to add extension for simulator which tells that it is kilo that’s mean ‘k’
							 */
							netlistUnit: '',
							/**
							 * exact name of parameter from netlist to be replaced
							 */
							mappingName: 'VgsMin',
							minBoundary: 6,
							maxBoundary: 19,
							defaultValue: 8
						},
						{
							heading: 'V<sub>GS<sub>(max)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'VgsMax',
							minBoundary: 7,
							maxBoundary: 20,
							defaultValue: 18
						},
						{
							heading: 'V<sub>GS<sub>(increment)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'VgsStep',
							minBoundary: 0.5,
							maxBoundary: 5,
							defaultValue: 1
						},
						{
							heading: 'V<sub>D<sub>(min)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'VdMin',
							minBoundary: 1,
							maxBoundary: 4,
							defaultValue: 1
						},
						{
							heading: 'V<sub>D<sub>(max)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'VdMax',
							minBoundary: 2,
							maxBoundary: 5,
							defaultValue: 4
						},
						{
							heading: 'V<sub>D<sub>(increment)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'VdStep',
							minBoundary: 0.5,
							maxBoundary: 5,
							defaultValue: 1
						},
						{
							heading: 't<sub>ambient<sub>',
							unit: UNITS_SIGN.CELSIUS,
							netlistUnit: '',
							mappingName: 'Tset',
							minBoundary: -40,
							maxBoundary: 150,
							defaultValue: 25,
							displayInput: true
						},
						{
							heading: 'Z<sub>RTH<sub>',
							unit: UNITS_SIGN.CELSIUSWATT,
							netlistUnit: '',
							mappingName: 'ThrImp',
							minBoundary: 0.0,
							maxBoundary: 0.3,
							defaultValue: 0.0434
						}
					]
				},
				{},
				{
					inputParameters: [
						{
							heading: 'V<sub>GS<sub>(max)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'VgsMax',
							minBoundary: 7,
							maxBoundary: 20,
							defaultValue: 17
						},
						{
							heading: 'V<sub>GS<sub>(min)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'VgsMin',
							minBoundary: 6,
							maxBoundary: 19,
							defaultValue: 7
						},
						{
							heading: 'V<sub>GS<sub>(step)</sub></sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'VgsStep',
							minBoundary: 0.5,
							maxBoundary: 10,
							defaultValue: 1
						},
						{
							heading: 'V<sub>DS</sub>',
							unit: UNITS_SIGN.VOLT,
							netlistUnit: '',
							mappingName: 'Vdrain',
							minBoundary: 1,
							maxBoundary: 5,
							defaultValue: 4,
							displayInput: true
						},
						{
							heading: 't<sub>ambient<sub>MAX</sub></sub>',
							unit: UNITS_SIGN.CELSIUS,
							netlistUnit: '',
							mappingName: 'tMax',
							minBoundary: -54,
							maxBoundary: 175,
							defaultValue: 150
						},
						{
							heading: 't<sub>ambient<sub>MIN</sub></sub>',
							unit: UNITS_SIGN.CELSIUS,
							netlistUnit: '',
							mappingName: 'tMin',
							minBoundary: -55,
							maxBoundary: 174,
							defaultValue: -30
						},
						{
							heading: 't<sub>ambient<sub>STEPS</sub></sub>',
							unit: UNITS_SIGN.NOUNITS,
							netlistUnit: '',
							mappingName: 'tStep',
							minBoundary: 1,
							maxBoundary: 15,
							defaultValue: 10
						},
						{
							heading: 'Z<sub>RTH<sub>',
							unit: UNITS_SIGN.CELSIUSWATT,
							netlistUnit: '',
							mappingName: 'ThrImp',
							minBoundary: 0.0,
							maxBoundary: 0.3,
							defaultValue: 0.0434
						}
					]
				}
			]
		};

		return super.gainDefinition(customizations);
	}
}
